import type { ReactNode } from "react";
import { FormProvider as RHFProvider } from "react-hook-form";
import type { FieldValues, UseFormReturn } from "react-hook-form";

export type FormProviderProps<
  FormValues extends FieldValues,
  ValidatedValues = FormValues,
> = {
  form: UseFormReturn<FormValues, unknown, ValidatedValues> & {
    submit: Function;
    resetForm: Function;
  };
  children: ReactNode;
};

export function FormProvider<
  FormValues extends FieldValues,
  ValidatedValues = FormValues,
>({ form, children }: FormProviderProps<FormValues, ValidatedValues>) {
  return <RHFProvider {...form}>{children}</RHFProvider>;
}
